"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePairContract = void 0;
var react_1 = require("react");
var Pair_json_1 = __importDefault(require("../abi/Pair.json"));
var useWeb3_1 = require("../shared/hooks/useWeb3/useWeb3");
function usePairContract(address) {
    var web3 = (0, useWeb3_1.useWeb3Provider)().web3;
    return (0, react_1.useMemo)(function () {
        return web3 && address
            ? new web3.eth.Contract(Pair_json_1.default, address)
            : undefined;
    }, [web3, address]);
}
exports.usePairContract = usePairContract;
